import { render, staticRenderFns } from "./Mini.vue?vue&type=template&id=21b253c1&"
import script from "./Mini.vue?vue&type=script&lang=js&"
export * from "./Mini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports